import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { message, Form, Icon, Input, Button, Row } from 'antd';

import { setUser, checkIfLoggedin } from '../user/actions';

import { URL_ENDPOINT } from '../../index';

const FormItem = Form.Item;

class LoginForm extends React.Component{
	render(){
		
		const { getFieldDecorator } = this.props.form;

		if(this.props.user.loggedIn){
			return (<Redirect to='/orders' />)
		}

		return (
			<Form onSubmit={this.handleSubmit}>

				<FormItem>
          {getFieldDecorator('email', {
            rules: [
							{ required: true, message: 'Please input your email!' },
							{ type: 'email', message: 'The input is not valid E-mail!'},
						],
          })(
            <Input prefix={<Icon type="mail" />} placeholder="Email" />
          )}
				</FormItem>

				<FormItem>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your password!' }],
          })(
            <Input type="password" prefix={<Icon type="key" />} placeholder="Password" />
          )}
				</FormItem>

				<Row type='flex' justify='end'>
					<Button type="primary" htmlType="submit" className="login-form-button">
						Log in
					</Button>
				</Row>

			</Form>
		)
	}

	constructor(props){
		super(props);

		this.state = {
			error: false
		}

		this.props.checkIfLoggedin();
	}

	handleSubmit = (e) => {
		e.preventDefault();

		this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {

				axios({
					url:`${URL_ENDPOINT}/api/user/login/admin/`,
					method:'post',
					data: values,
					withCredentials: true
				})
					.then( res => {
						// dispatch redux 
						this.props.setUser(res.data.user);
					})
					.catch( error => {
						message.error(`${error.response.data.err.message}. Admin does not exist.`);
					})
      }
    });

	}
}

export default connect(
	state => ({
		user: state.user
	}),

	dispatch => ({
		setUser: (user) => dispatch(setUser(user)),
		checkIfLoggedin: () => dispatch(checkIfLoggedin())
	})

)(Form.create({})(LoginForm));


// WEBPACK FOOTER //
// ./src/components/login/index.js